export default __webpack_public_path__ + "static/media/royal-garden_3.27d476c9.jpg";